export default {
  getStrDateTime(value = '') {
    const js_date = new Date(value);

    // 연도, 월, 일 추출
    const year = js_date.getFullYear();
    let month = js_date.getMonth() + 1;
    let day = js_date.getDate();
    let hour = js_date.getHours();
    let min = js_date.getMinutes();

    // 월, 일의 경우 한자리 수 값이 있기 때문에 공백에 0 처리
    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (min < 10) {
      min = '0' + min;
    }
    // 최종 포맷 (ex - '2021-10-08')
    return this.nvl(value, '') != '' && value != null ? year + '-' + month + '-' + day + ' ' + hour + ':' + min : '';
  },
  getStrDateTime2(value = '') {
    const js_date = new Date(value);

    // 연도, 월, 일 추출
    const year = js_date.getFullYear();
    let month = js_date.getMonth() + 1;
    let day = js_date.getDate();
    let hour = js_date.getHours();
    let min = js_date.getMinutes();

    // 월, 일의 경우 한자리 수 값이 있기 때문에 공백에 0 처리
    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (min < 10) {
      min = '0' + min;
    }
    // 최종 포맷 (ex - '2021-10-08')
    return this.nvl(value, '') != '' && value != null ? (''+year).substring(2,4) + '-' + month + '-' + day + ' ' + hour + ':' + min : '';
  },
  getStrDate(value = '', format = '-') {
    const js_date = new Date(value);

    // 연도, 월, 일 추출
    const year = js_date.getFullYear();
    let month = js_date.getMonth() + 1;
    let day = js_date.getDate();

    // 월, 일의 경우 한자리 수 값이 있기 때문에 공백에 0 처리
    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }
    // 최종 포맷 (ex - '2021-10-08')
    return this.nvl(value, '') != '' ? year + format + month + format + day : '';
  },
  getStrDate2(value = '', format = '-') {
    const js_date = new Date(value);

    // 연도, 월, 일 추출
    const year = js_date.getFullYear();
    let month = js_date.getMonth() + 1;
    let day = js_date.getDate();

    // 월, 일의 경우 한자리 수 값이 있기 때문에 공백에 0 처리
    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }
    // 최종 포맷 (ex - '2021-10-08')
    return this.nvl(value, '') != '' ? (''+year).substring(2,4) + format + month + format + day : '';
  },
  getStrDate3(value = '', format = '-') {
    const js_date = new Date(value);
    //  월, 일 추출
    let month = js_date.getMonth() + 1;
    let day = js_date.getDate();

    // 월, 일의 경우 한자리 수 값이 있기 때문에 공백에 0 처리
    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }
    // 최종 포맷 (ex - '10-08')
    return this.nvl(value, '') != '' ? month + format + day : '';
  },
  getStrDate4(value = '') {
    const js_date = new Date(value);

    // 연도, 월, 일 추출
    const year = js_date.getFullYear();
    let month = js_date.getMonth() + 1;
    let day = js_date.getDate();

    // 월, 일의 경우 한자리 수 값이 있기 때문에 공백에 0 처리
    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }
    // 최종 포맷 (ex - '2021-10-08')
    return this.nvl(value, '') != '' ? year + '년 ' + month + '월 ' + day + '일' : '';
  },
  getStrWeekName(value = '') {
    const js_date = new Date(value);
    let weekday = js_date.getDay();
    let weekName = ['일','월','화','수','목','금','토'];
    return weekName[weekday];
  },
  /**
   * 날짜에 일 수를 더하거나 뺍니다.
   * @param {Date} date - 기준 날짜
   * @param {number} days - 더하거나 뺄 일 수
   * @return {Date} 변경된 날짜
   */
  changeDate(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },
  /**
   * 주말과 공휴일을 제외하고 1일 전 날짜를 구합니다.
   * @param {Date} date - 기준 날짜
   * @param {Array} holidays - 공휴일 날짜의 배열 (예: ['2024-01-01', '2024-03-01'])
   * @return {Date} 변경된 날짜
   */
  getPreviousWeekday(date, holidays) {
    let result = new Date(date);
    //console.log(holidays)
    do {
      result = this.changeDate(result, -1); // 일단 1일 전으로 설정
      var isWeekend = result.getDay() === 0 || result.getDay() === 6; // 주말인지 확인
      var isHoliday = holidays.includes(this.getStrDate(result)); // 공휴일인지 확인
      //console.log(this.getStrDate(result))
      //console.log(isWeekend)
      //console.log(isHoliday)
    } while (isWeekend || isHoliday); // 주말이거나 공휴일이면 반복
    //console.log(result);

    return result;
  },
  getUseYN(value = '') {
    let strUse = '사용안함';
    if (value == '1' || value.toUpperCase() == 'Y') {
      strUse = '사용';
    }
    return strUse;
  },
  getUseYN2(value = '') {
    let strUse = '미사용';
    if (value == '1' || value.toUpperCase() == 'Y') {
      strUse = '사용';
    }
    return strUse;
  },
  getAprvYn(value = '') {
    let strUse = '미승인';
    if (value == '1' || value.toUpperCase() == 'Y') {
      strUse = '승인';
    }
    return strUse;
  },
  ipToInt(ip) {
    let ipl=0;
    ip.split('.').forEach((octet) => {
      ipl<<=8;
      ipl+=parseInt(octet);
    });
    return(ipl >>>0);
  },
  ipFromLong(ipl) {
    return ( (ipl>>>24) + '.' +
      (ipl>>16 & 255) + '.' +
      (ipl>>8 & 255) + '.' +
      (ipl & 255)
    );
  },
  setCurrencyComma(value) {
    // 숫자 천단위 comma찍기
    const num = Number(value);
    return (isNaN((num)))?0:num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
  },
  setNumber(value, point=false) {
    if(point) value = value.toString().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    else value = value.toString().replace(/[^0-9]/g, '')
    return value
  },
  getDraftClNm(idx) {
    const draftCl = parseInt(idx);
    switch (draftCl) {
      case 1 :
        return '초안'
      case 99 :
        return '최종'
      case 100 :
        return 'AS'
      default :
        return draftCl+'차';
    }
  },
  getDraftClNm2(idx) {
    const draftCl = parseInt(idx);
    switch (draftCl) {
      case 1 :
        return '초안'
      case 99 :
        return '최종 시안'
      case 100 :
        return 'AS 시안'
      default :
        return draftCl+'차 수정 시안';
    }
  },
  getfileSize(x) {
    // 데이터 사이즈 계산
    var s = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    var e = Math.floor(Math.log(x) / Math.log(1024));
    return (parseInt(this.nvl(x,'0')) === 0)?'-':(x / Math.pow(1024, e)).toFixed(2) + " " + s[e];
  },
  setHyphenPhone(phoneNumber) {
    if (!phoneNumber) return phoneNumber

    phoneNumber = phoneNumber.replace(/[^0-9]/g, '')

    let tmp = ''
    if (phoneNumber.length < 4) {
      return phoneNumber;
    }
    else if (phoneNumber.length < 7) {
      tmp += phoneNumber.substr(0, 3);
      tmp += '-';
      tmp += phoneNumber.substr(3);
      return tmp;
    }
    else if (phoneNumber.length == 8) {
      tmp += phoneNumber.substr(0, 4);
      tmp += '-';
      tmp += phoneNumber.substr(4);
      return tmp;
    }
    else if (phoneNumber.length < 10) {
      if (phoneNumber.substr(0, 2) == '02') { //02-123-5678
        tmp += phoneNumber.substr(0, 2);
        tmp += '-';
        tmp += phoneNumber.substr(2, 3);
        tmp += '-';
        tmp += phoneNumber.substr(5);
        return tmp;
      } else {
        return phoneNumber;
      }
    }
    else if (phoneNumber.length < 11) {
      if (phoneNumber.substr(0, 2) == '02') { //02-1234-5678
        tmp += phoneNumber.substr(0, 2);
        tmp += '-';
        tmp += phoneNumber.substr(2, 4);
        tmp += '-';
        tmp += phoneNumber.substr(6);
        return tmp;
      } else { //010-123-4567
        tmp += phoneNumber.substr(0, 3);
        tmp += '-';
        tmp += phoneNumber.substr(3, 3);
        tmp += '-';
        tmp += phoneNumber.substr(6);
        return tmp;
      }
    }
    else { //010-1234-5678
      tmp += phoneNumber.substr(0, 3);
      tmp += '-';
      tmp += phoneNumber.substr(3, 4);
      tmp += '-';
      tmp += phoneNumber.substr(7);
      return tmp;
    }

  },
  deleteBracket(text) { // 안녕 (hi) 하세요 -> 안녕 하세요
    var find1 = text.indexOf('(')
    var find2 = text.indexOf(')')
    if( find1 > -1 && find2 > -1 ) {
      text = text.substr( 0, find1-1 ) + text.substr( find2+1, text.length );
    }

    return text;
  },
  getTelNumValidation(value){
    let reg = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))(\d{3,4})(\d{4})$/;
    // 핸드폰일때(010, 011, 019, ..., 017)
    if( value.substr(0, 2) == "01" ){
      reg = /^(?:(010-\d{4})|(01[1|6|7|8|9]-\d{3,4}))(\d{4})$/;
    }
    return reg.test(value);
  },
  nvl(expr1, expr2) {
    if (expr1 === undefined || expr1 === "undefined" || expr1 == null || expr1 == "" || expr1 == "null") {
      expr1 = expr2;
    }
    return expr1;
  },
  nullClean: function(obj){
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || propName == "frstRegDt" || propName == "lastRegDt") {
        delete obj[propName];
      } else if(propName.indexOf('Ymd') > 0 || propName.indexOf('Dt') > 0){
        obj[propName]  = this.getStrDate(obj[propName]);
      }
    }
    return obj;
  },
  /* 그리드 sorting 값 */
  getGridSortData(gridApi){
    let sortParam = {};
    let col = gridApi.columnApi.columnModel;

    for( let i = 0; i < col.gridColumns.length; i++ ){
      if( this.nvl(col.gridColumns[i].sort, "") != "" ){
        // console.log("ssss ==> ", col.gridColumns[i]);
        // sortParam.orderKey = col.gridColumns[i].colId;
        sortParam.orderKey = col.gridColumns[i].colDef.orderKeyCol;
        sortParam.direction = col.gridColumns[i].sort;
        break;
      }
    }

    return sortParam;
  },
  /* 사업자 등록번호 정규식 체크 */
  regBrnoChk(brno){
    let brnoMap = brno.replace(/-/gi, '').split('').map(function (d){
      return parseInt(d, 10);
    });

    if( brnoMap.length == 10 ){
      // 사업자 등록번호 체크하는 인증키
      let keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
      let chk = 0;

      // 사업자번호 10자리 중 앞 9자리 인증키 9자리의 각 자리수를 각각 곱하여 전부 더해줍니다.
      keyArr.forEach(function(d, i){
        chk += d * brnoMap[i];
      });
      /**
       * 사업자번호 뒤에서 2번째자리와 인증키 마지막 값을 곱하고 10으로 나눈 후 위의 합과 추가로 더해줍니다.
       * 합계를 10으로 나머지 연산을 합니다.
       */
      chk += parseInt((keyArr[8] * brnoMap[8])/ 10, 10);

      /**
       * 10에서 나머지 연산의 값을 빼줍니다.
       * 사업자번호 마지막자리와 마지막 처리한값이 같으면 사업자번호입니다.
       */
      return Math.floor(brnoMap[9]) === ( (10 - (chk % 10) ) % 10);
    }

    return false;
  },
  handleNewLine: function(str) {
    return this.nvl(str,'').replace(/(?:\r\n|\r|\n)/g, '<br />');
  },
  stripHtmlTags(inputString) {
    return inputString.replace(/<[^>]*>/g, '');
  },
  getDdlvyHrTimeText: function(idx) {
    if(idx < 12) return "a.m. "+idx;
    else if(idx == 12) return "정오 "+idx;
    else if(idx < 24) return "p.m. "+idx;
    else if(idx == 24) return "자정 "+idx;
    else return "-";
  },
  printElement(elementRef, titleName, cssName) {
    // console.log(elementRef)
    let app = document.getElementById('app')
    const printContents = elementRef.innerHTML
    let printDiv = document.createElement('DIV')

    document.body.appendChild(printDiv)
    printDiv.innerHTML = printContents
    app.style.display = 'none'
    printDiv.classList.add(cssName);
    let tempTitle = document.title;
    document.title = titleName;

    setTimeout(() => {
      window.print();

      app.style.display = 'block'
      printDiv.style.display = 'none'
      printDiv.innerHTML = ''
      document.title = tempTitle;
    },100);
  },
  getCustNote() {
    return '<p>* 오탈자 여부 확인 부탁드립니다. 확정 후 제작이 시작되면 수정 불가합니다.</p>' +
        '<p>* 수정 및 확정 여부는 하단의 수정사항란 또는 메일로 부탁드립니다.</p>';
  },
  getWeeknumbers:function (value){
      const js_date = new Date(value);

      // Get the first day of the year
      const year = js_date.getFullYear();
      const firstDayOfYear = new Date(year, 0, 1);
      // Get the day of the week for the first day
      let firstDayWeekday = firstDayOfYear.getDay();

      // Calculate the start date of the first week
      let startOfFirstWeek;
      if (firstDayWeekday === 5 || firstDayWeekday === 6) {
        // If the first day is Friday or Saturday, set the first week to start from the next Sunday
        startOfFirstWeek = new Date(firstDayOfYear.getTime() + (7 - firstDayWeekday) * 24 * 60 * 60 * 1000);
      } else {
        startOfFirstWeek = firstDayOfYear;
      }

      // Check if the date is in the last week of the year
      const lastDayOfYear = new Date(year, 11, 28);
      if(js_date >= lastDayOfYear) {
        return 1;
      }
      //let lastDayWeekday = lastDayOfYear.getDay();
      //let startOfLastWeek = new Date(lastDayOfYear.getTime() - lastDayWeekday * 24 * 60 * 60 * 1000);
      //if (js_date >= startOfLastWeek) {
        // If the date is in the last week of the year, return the last week number
      //  let totalDays = (lastDayOfYear - startOfFirstWeek) / (24 * 60 * 60 * 1000) + 1;
      //  return Math.ceil(totalDays / 7);
      //}

      // Calculate the difference between the date and the start of the first week in milliseconds
      let difference = js_date - startOfFirstWeek;
      // Convert the difference to weeks
      let weekNumber = Math.ceil(difference / (7 * 24 * 60 * 60 * 1000));

      return weekNumber + 1; // Counting the first week as week 1

  },
  getMonthFromYearAndWeek(year, week) {
    // 해당 연도의 첫 날
    const firstDayOfYear = new Date(year, 0, 1);
    let firstDayWeekday = firstDayOfYear.getDay();

    // 첫 주의 시작일 계산
    let startOfFirstWeek;
    if (firstDayWeekday === 5 || firstDayWeekday === 6) {
      // 첫 날이 금요일(5) 또는 토요일(6)인 경우 → 다음 주 일요일부터 첫 주 시작
      startOfFirstWeek = new Date(firstDayOfYear.getTime() + (7 - firstDayWeekday) * 24 * 60 * 60 * 1000);
    } else {
      startOfFirstWeek = firstDayOfYear;
    }

    // 목표 주차의 시작일 = 첫 주 시작일 + (week - 1)주
    const targetDate = new Date(startOfFirstWeek.getTime() + (week - 1) * 7 * 24 * 60 * 60 * 1000);

    // 월은 0부터 시작하는 값으로 리턴
    return targetDate.getMonth();
  },
  getWeekStartDate(value) {
    const js_date = new Date(value);
    // getDay()는 일요일(0)부터 토요일(6)까지 반환하므로,
    // 입력 날짜에서 해당 요일 수만큼 빼면 일요일(주 시작일)을 구할 수 있습니다.
    const dayOfWeek = js_date.getDay();
    return new Date(js_date.getTime() - dayOfWeek * 24 * 60 * 60 * 1000);
  },
  getWeekStartEndDates(value) {
    const js_date = new Date(value);
    // getDay()는 일요일(0)부터 토요일(6)까지 반환하므로,
    // 입력 날짜에서 해당 요일 수만큼 빼면 일요일(주 시작일)을 구할 수 있습니다.
    const dayOfWeek = js_date.getDay();
    const startOfWeek = new Date(js_date.getTime() - dayOfWeek * 24 * 60 * 60 * 1000);
    // 시작일에 6일을 더하면 주의 종료일(토요일)이 됩니다.
    const endOfWeek = new Date(startOfWeek.getTime() + 6 * 24 * 60 * 60 * 1000);
    return { start: startOfWeek, end: endOfWeek };
  }
}
